export default __webpack_public_path__ + "static/media/logo-extra.aeeff780.png";